"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericJobState = void 0;
var GenericJobState;
(function (GenericJobState) {
    GenericJobState["Active"] = "Active";
    GenericJobState["Error"] = "Error";
    GenericJobState["Completed"] = "Completed";
})(GenericJobState = exports.GenericJobState || (exports.GenericJobState = {}));
//# sourceMappingURL=generic-job-state.js.map